import React from 'react'
import { styled } from '@tools/wr-catalog-base'

const Container = styled.label`
  position: relative;
  display: inline-block;
  width: 2.6em;
  height: 1.5em;
  vertical-align: middle;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  input:checked + {
    span {
      background-color: var(--color-green);
      :before {
        transform: translateX(1.1em);
      }
    }
  }
  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 9999px;

    &:before {
      position: absolute;
      content: '';
      height: 1.1em;
      width: 1.1em;
      left: 0.2em;
      top: 0.2em;
      background-color: white;
      border-radius: 9999px;
      transition: 0.4s;
    }
  }
`

export default function Toggle(props) {
  return (
    <Container className={props.className}>
      <input type="checkbox" name={props.name} checked={props.checked} onChange={props.onChange} />
      <span />
    </Container>
  )
}
